import React from "react";
import { Route, Switch } from "react-router-dom";
import AllFieldNotes from "../packageSidebar/AllFieldNotes";
import FieldNote from "../packageDetails/FieldNote";
import FieldNoteSubmit from "./FieldNoteSubmit";
import FieldNoteWriter from "./FieldNoteWriter";
import FieldNotePreview from "./FieldNotePreview";
import FieldNoteAuthor from "./FieldNoteAuthor";
import FieldNoteAccess from "./FieldNoteAccess";

function FieldNotesRouter() {
  return (
    <Switch>
      <Route exact path="/fieldnotes/submit" component={FieldNoteSubmit} />
      <Route exact path="/fieldnotes/access" component={FieldNoteAccess} />
      <Route exact path="/fieldnotes/write/:token" component={FieldNoteWriter} />
      <Route exact path="/fieldnotes/preview/:token" component={FieldNotePreview} />
      <Route exact path="/fieldnotes/author/:authorSlug" component={FieldNoteAuthor} />
      <Route exact path="/fieldnotes" component={AllFieldNotes} />
      <Route exact path="/fieldnotes/:slug" component={FieldNote} />
    </Switch>
  );
}

export default FieldNotesRouter;
